import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Box,
  Chip,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { HistoryType } from '../../types/history.types';

interface DayEvent {
  id: string;
  title: string;
  type: HistoryType;
  moldName: string;
}

interface DayEventsModalProps {
  open: boolean;
  date: Date | null;
  events: DayEvent[];
  onClose: () => void;
  onEventClick: (eventId: string) => void;
  typeColors: Record<HistoryType, string>;
  typeLabels: Record<HistoryType, string>;
}

export const DayEventsModal: React.FC<DayEventsModalProps> = ({
  open,
  date,
  events,
  onClose,
  onEventClick,
  typeColors,
  typeLabels,
}) => {
  if (!date) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">
          {format(date, 'M월 d일 (eee)', { locale: ko })} 이력
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers>
        {events.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
            이 날짜에 등록된 이력이 없습니다.
          </Typography>
        ) : (
          <List disablePadding>
            {events.map((event) => (
              <ListItem key={event.id} disablePadding>
                <ListItemButton onClick={() => onEventClick(event.id)}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip
                        label={typeLabels[event.type]}
                        size="small"
                        sx={{
                          backgroundColor: typeColors[event.type],
                          color: 'white',
                          fontSize: '11px',
                        }}
                      />
                      <Typography variant="body2" color="text.secondary">
                        {event.moldName}
                      </Typography>
                    </Box>
                    <ListItemText primary={event.title} />
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};
